import React from "react";
import { Button, Flex } from "antd";
import "./NormalButton.scss";

const NormalButton = ({
  text = "Add User",
  children,
  className = "",
  type = "default",
  onClick,
  width = "100%",
  loading = false,
  prefixIcon = null,
  suffixIcon = null,
  controlHeight = 42,
  ...restProps
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Flex className={`normal-button ${className}`}>
      <Button
        type={type}
        onClick={handleClick}
        loading={loading}
        {...restProps}
        style={{ width: width, height: controlHeight }}
        className="normal-btn-container"
      >
        <span className="button-content">
          {prefixIcon && <span className="prefix-icon">{prefixIcon}</span>}
          {children || text}
          {suffixIcon && <span className="suffix-icon">{suffixIcon}</span>}
        </span>
      </Button>
    </Flex>
  );
};

export default NormalButton;
